import { AppSettingsValue, Setting } from "../types";

/** API иногда отдаёт settings_value как JSON-строку (в т.ч. двойную). */
export function normalizeSettingsValue(value: unknown): AppSettingsValue | null {
  let current: unknown = value;

  for (let i = 0; i < 3; i++) {
    if (current == null || current === "") return null;
    if (typeof current === "object" && !Array.isArray(current)) {
      return current as AppSettingsValue;
    }
    if (typeof current === "string") {
      try {
        current = JSON.parse(current);
      } catch {
        return null;
      }
      continue;
    }
    return null;
  }

  return typeof current === "object" && current !== null && !Array.isArray(current)
    ? (current as AppSettingsValue)
    : null;
}

export function getAppConfig(settings: Setting[]): AppSettingsValue | null {
  const row = settings.find((s) => s.type.startsWith("app_"));
  if (!row) return null;
  return normalizeSettingsValue(row.settings_value);
}

export function getTelegramBotUsername(appConfig: AppSettingsValue | null): string | null {
  const raw = appConfig?.botName;
  if (typeof raw !== "string") return null;
  const username = raw.trim().replace(/^@/, "");
  return username || null;
}
